import ErgeonLogo from '@ergeon/core-components/src/components/core/Logo/assets/ergeon-logo-blue.svg?react';

// The design system ships the wordmark with the blue baked into the path's
// fill attribute, so it cannot be inherited away. Targeting the path from CSS
// overrides the presentation attribute and gets the dark theme a white
// wordmark without a second asset.
export default function Logo({ className }: { className?: string }) {
  return (
    <ErgeonLogo
      aria-label="Ergeon"
      className={`h-7 w-auto shrink-0 text-blue-500 [&_path]:fill-current dark:text-white ${className ?? ''}`}
      role="img"
    />
  );
}
